import React from 'react';
import { dateOptions, dateTimeOptions } from '../../../utils/dates';

const HydrantFlushReport = ({ hydrantFlush }) => {

  return (
    <tr>
      <td>
        <div className="hydrant-flush-summary">
          <div className="summary-details">
            <div className="summary-detail">
              <label>Hydrant:</label>
              <span>{hydrantFlush?.hydrant?.name}</span>
            </div>
          </div>
          <div className="flush-stats">
            <div className="flush-stat">
              <label>Flush Date:</label>
              <span>{hydrantFlush?.startDate ? new Date(hydrantFlush.startDate).toLocaleDateString('en-US', dateOptions) : ''}</span>
            </div>
            <div className="flush-stat">
              <label>Flow Device:</label>
              <span>{hydrantFlush?.flowDevice?.name}</span>
            </div>
            <div className="flush-stat">
              <label>Gallons Used:</label>
              <span>{hydrantFlush?.gallonsUsed}</span>
            </div>
            <div className="flush-stat">
              <label>Start Clarity:</label>
              <span>{hydrantFlush?.startClarity}</span>
            </div>
            <div className="flush-stat">
              <label>During Clarity:</label>
              <span>{hydrantFlush?.duringClarity}</span>
            </div>
            <div className="flush-stat">
              <label>End Clarity:</label>
              <span>{hydrantFlush?.endClarity}</span>
            </div>
            <div className="flush-stat">
              <label>Flow PSI:</label>
              <span>{hydrantFlush?.maxPsi ?? 0}</span>
            </div>
            <div className="flush-stat">
              <label>Flow GPM:</label>
              <span>{hydrantFlush?.maxGpm ?? 0}</span>
            </div>
          </div>
        </div>
      </td>
    </tr>
  )
};

export default HydrantFlushReport;